<template>
    <div class="down">
        <p v-for="(parent, i) in popData.all_parents" :key="i">
            <span>{{parent.guanxi ? parent.guanxi : '家长'}}：{{parent.name ? parent.name : '--'}}</span>
            <span class="left_m">联系方式：{{parent.phone ? parent.phone : '--'}}</span>
        </p>
        <span>姓名：{{popData.baobao_name ? popData.baobao_name : '--'}}</span>
        <span class="left_m">昵称：{{popData.baobao_name2 ? popData.baobao_name2 : '--'}}</span>
        <span>性别：{{popData.baobao_sex ? popData.baobao_sex : '--'}}</span>
        <span class="left_m">生日：{{popData.baobao_birthday ? popData.baobao_birthday : '--'}}</span>
        <span>联系地址：{{popData.site ? popData.site : '--'}}</span>
        <span class="left_m">备注：{{popData.beizhu ? popData.beizhu : '--'}}</span>
    </div>
</template>

<script>
export default {
    name: "genjinInfoBox",  //  跟进模块 右侧弹窗 显示家长信息组件
    data() {
        return {};
    },
    props: [
        "popData"
    ]
};
</script>
<style lang="less" scoped>
.down {
    padding: 25px;
    span {
        display: inline-block;
        width: 40%;
        height: 36px;
        line-height: 36px;
        color: #666;
        border-bottom: 1px solid #eee;
        font-size: 14px;
    }
    .left_m {
        margin-left: 5%;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/genjinInfoBox.vue